import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TicketService {
  // noAuthHeader = { headers: new HttpHeaders({ 'NoAuth': 'True' }) };
  constructor(private http: HttpClient) { }

  raiseTicket(issue,fileToUpload){
    console.log(fileToUpload)
    const formData =new FormData()
    issue.uploaderId="papa";
    formData.append('data',JSON.stringify(issue))
    if(fileToUpload)
    formData.append('file',fileToUpload)

    formData.forEach((value,key) => {
      console.log(key+" "+value)
    });
    const req = this.http.post<any>(environment.apiBaseUrl+`/customer/raise-ticket`, formData);
    console.log(req);
    return req;
  }

  getAllTickets() {
    return this.http.get(environment.apiBaseUrl + '/customer/get-all-tickets')
  }

  getAllAttachments(ticketID) {
    
    return this.http.post<any>(environment.apiBaseUrl + '/customer/get-all-attachments',ticketID)
  }
  
  closeTicket(ticketID) {
    return this.http.post<any>(environment.apiBaseUrl+`/customer/close-ticket`, ticketID);
  }

  sendFeedback(feedback) {
    return this.http.post<any>(environment.apiBaseUrl+`/customer/feedback`, feedback);
  }
}
